(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.GenerateKeyFieldsService = (function(superClass) {
    extend(GenerateKeyFieldsService, superClass);

    function GenerateKeyFieldsService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.deleteKeyFields = bind(this.deleteKeyFields, this);
      this.saveKeyFields = bind(this.saveKeyFields, this);
      this.generate = bind(this.generate, this);
      this.buildMatViews = bind(this.buildMatViews, this);
      this.getAlgorithms = bind(this.getAlgorithms, this);
      this.getYears = bind(this.getYears, this);
      this.getCompanies = bind(this.getCompanies, this);
      void 0;
    }

    GenerateKeyFieldsService.prototype.getCompanies = function() {
      return this.http.post('backend/admin/new-tools/generate-key-fields/get-companies');
    };

    GenerateKeyFieldsService.prototype.getYears = function() {
      return this.http.post('backend/admin/new-tools/generate-key-fields/get-years');
    };

    GenerateKeyFieldsService.prototype.getAlgorithms = function() {
      return this.http.post('backend/admin/new-tools/generate-key-fields/get-algorithms');
    };

    GenerateKeyFieldsService.prototype.buildMatViews = function(companyId, advisorId, year, algorithm) {
      return this.http.post('backend/admin/new-tools/generate-key-fields/build-mat-views', {
        companyId: companyId,
        advisorId: advisorId,
        year: year,
        algorithm: algorithm
      });
    };

    GenerateKeyFieldsService.prototype.generate = function(companyId, advisorId, year, algorithm) {
      return this.http.post('backend/admin/new-tools/generate-key-fields/generate', {
        companyId: companyId,
        advisorId: advisorId,
        year: year,
        algorithm: algorithm
      });
    };

    GenerateKeyFieldsService.prototype.saveKeyFields = function(companyId, advisorId, year, fields) {
      return this.http.post('backend/admin/new-tools/generate-key-fields/save-fields', {
        companyId: companyId,
        advisorId: advisorId,
        year: year,
        fields: fields
      });
    };

    GenerateKeyFieldsService.prototype.deleteKeyFields = function(companyId, advisorId, year) {
      return this.http.post('backend/admin/new-tools/generate-key-fields/delete-fields', {
        companyId: companyId,
        advisorId: advisorId,
        year: year
      });
    };

    return GenerateKeyFieldsService;

  })(Service);

}).call(this);
